import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base";
import { getESGReqHeader } from "./tool-service";

export const getAnalyzeInitData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2030101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2030101")}`, method: "post", data: ReqBody });
};

export const getCompanyStatsList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2030201"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2030201")}`, method: "post", data: ReqBody });
};

export const B2030202Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader("B2030202"),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2030202",true)}`, method: 'post', data: ReqBody })
}

export const updateS3BucketUsage = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2030202"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2030202")}`, method: "post", data: ReqBody });
};

export const getDashboardData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2040101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2040101")}`, method: "post", data: ReqBody });
};
